import React from "react";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import NotificationSvg from "assets/icons/notification.svg";
import SearchBlack from "assets/icons/searchBlack.svg";

import { HeadH1 } from "./CommunityHeaderStyle";

const CommunityHeader = () => {
  const navigate = useNavigate();

  return (
    <HeadH1>
      <img
        className="img__left"
        src={NotificationSvg}
        alt="notification"
        onClick={() => navigate("/alarm")}
      />
      <div>커뮤니티</div>
      <Link to="/boards/search">
        <img className="img__right" src={SearchBlack} alt="Search icon" />
      </Link>
    </HeadH1>
  );
};

export default CommunityHeader;
